import api from './index'

/**
 * 一键生成门头设计
 * @param {Object} data 设计参数
 * @param {string} data.prompt 提示词
 * @param {boolean} data.return_url 是否返回URL
 * @param {boolean} data.use_pre_llm 是否使用预LLM
 * @param {Object} data.logo_info Logo信息
 * @param {number} data.width 图片宽度
 * @param {number} data.height 图片高度
 * @returns {Promise}
 */
export const generateDesign = (data) => {
  return api.post('/api/cv/process', data)
}

/**
 * 一键同款生成
 * @param {Object} data 生成参数
 * @param {string} data.reference_image 参考图URL
 * @param {string} data.prompt 提示词
 * @param {string} data.description 门头名称
 * @param {boolean} data.return_url 是否返回URL
 * @param {number} data.width 图片宽度
 * @param {number} data.height 图片高度
 * @param {string} data.req_key 请求标识
 * @returns {Promise}
 */
export const generateSameDesign = (data) => {
  return api.post('/api/one-click/generate', data)
}

/**
 * 现场还原AI修改
 * @param {Object} data 修改参数
 * @param {string} data.effectImage 效果图URL
 * @param {string} data.siteImage 现场图URL
 * @returns {Promise}
 */
export const aiModify = (data) => {
  return api.post('/api/cv/modify', data)
}

/**
 * 获取设计历史记录
 * @param {Object} params 查询参数
 * @param {number} params.limit 每页数量
 * @param {number} params.offset 偏移量
 * @returns {Promise}
 */
export const getDesignHistory = (params = {}) => {
  return api.get('/api/cv/history', { params })
}

/**
 * 下载设计作品
 * @param {string} designId 设计ID
 * @returns {Promise}
 */
export const downloadDesign = (designId) => {
  return api.get(`/design/download/${designId}`, { responseType: 'blob' })
}

/**
 * 重新编辑设计
 * @param {string} designId 设计ID
 * @returns {Promise}
 */
export const reeditDesign = (designId) => {
  return api.post(`/design/reedit/${designId}`)
}

/**
 * 重新生成设计
 * @param {string} designId 设计ID
 * @returns {Promise}
 */
export const regenerateDesign = (designId) => {
  return api.post(`/design/regenerate/${designId}`)
}

/**
 * 获取一键同款生成记录
 * @param {Object} params 查询参数
 * @param {number} params.limit 每页数量
 * @param {number} params.offset 偏移量
 * @returns {Promise}
 */
export const getSameDesignHistory = (params = {}) => {
  return api.get('/api/one-click/history', { params })
}

/**
 * 上传图片
 * @param {FormData} formData 包含图片的表单数据
 * @returns {Promise}
 */
export const uploadImage = (formData) => {
  return api.post('/api/cv/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 获取图片列表
 * @param {Object} params 查询参数
 * @param {number} params.page 页码，默认为1
 * @param {number} params.limit 每页数量，默认为20
 * @returns {Promise}
 */
export const getImageList = (params = {}) => {
  // 将page参数转换为offset参数以兼容后端接口
  const { page = 1, limit = 20, ...otherParams } = params;
  // const offset = (page - 1) * limit;
  
  return api.get('/api/image-files/getList', { 
    params: { 
      page,
      limit,
      ...otherParams
    } 
  })
}

/**
 * 服装店AI修改生成
 * @param {Object} data 修改参数
 * @param {Array<string>} data.image_urls 原始图片URL数组
 * @param {string} data.prompt 提示词
 * @param {string} data.req_key 请求标识
 * @returns {Promise}
 */
export const modifyNew = (data) => {
  return api.post('/api/cv/modify-new', data)
}

/**
 * 获取服装店修改历史记录
 * @param {Object} params 查询参数
 * @param {number} params.limit 每页数量
 * @param {number} params.offset 偏移量
 * @returns {Promise}
 */
export const getModifyHistory = (params = {}) => {
  return api.get('/api/cv/modify-history', { params })
}

/**
 * 生成图片简介
 * @param {Object} data 生成参数
 * @param {string} data.image_url 图片URL
 * @param {string} data.brief 简介描述（可选）
 * @returns {Promise}
 */
export const generateImageBrief = (data) => {
  return api.post('/api/image-brief/generate', data)
}

/**
 * 获取图片简介历史记录
 * @param {Object} params 查询参数
 * @param {number} params.limit 每页数量
 * @param {number} params.offset 偏移量
 * @returns {Promise}
 */
export const getImageBriefHistory = (params = {}) => {
  return api.get('/api/image-brief/history', { params })
}